import * as yup from 'yup'

const validationSchema = yup.object().shape({
  azienda: yup.string().required('Questo campo è obbligatorio!'),
  nome: yup.string().required('Questo campo è obbligatorio!'),
  email: yup.string().email().required('Questo campo è obbligatorio!'),
  telefono: yup.string().required('Questo campo è obbligatorio!'),
  tipologia: yup.boolean().required('Questo campo è obbligatorio!'),
})

export default validationSchema
